import { Circle } from "@/atoms/Vectors";
import styles from "./index.module.scss";

interface Props {
  currentSlide: number;
  index: number;
  onClick: any;
  type: string;
  color: any[any];
  activeColor: any[any];
  length: number;
  label: string;
  custom?: any;
  spacer: boolean;
}

export const NavigationSlider = ({
  currentSlide,
  onClick,
  type,
  index,
  color,
  activeColor,
  length,
  label,
  custom,
  spacer,
}: Props) => {
  const style = {
    "--color": color?.hex,
    "--activeColor": activeColor?.hex,
    "--shape": `url(${custom?.img?.url})`,
  } as React.CSSProperties;
  switch (type) {
    case "dotted":
      return (
        <>
          <button
            style={style as React.CSSProperties}
            aria-label={"navigation slider buttons"}
            onClick={onClick}
            className={`${
              currentSlide === index ? `${styles.active}` : ""
            } relative  w-2 h-2 rounded-full overflow-hidden ${
              styles.dottedButton
            }`}
            key={index}
          >
            {currentSlide === index ? (
              <span
                style={style as React.CSSProperties}
                className={`absolute right-0 left-0 top-0 bottom-0 m-auto w-4 h-4 ${styles.active}`}
              ></span>
            ) : (
              <span
                style={style as React.CSSProperties}
                className={`absolute right-0 left-0 top-0 bottom-0 m-auto w-4 h-4 ${styles.dottedSpan}`}
              ></span>
            )}
          </button>
        </>
      );    case "numbered":
      return (
        <>
          <button
            aria-label={"navigation slider buttons"}
            onClick={onClick}
            className={`${
              currentSlide === index ? " md:scale-120" : ""
            } relative `}
            key={index}
          >
            <span
              className={`lg:hidden ${currentSlide === index ? "w-6" : "w-2"} h-2 block rounded-full transition-all`}
              style={{ backgroundColor: currentSlide === index ? activeColor?.hex : color?.hex }}
            />
            {currentSlide === index && (
              <span className="hidden lg:block">
                <Circle color={color?.hex} />
              </span>
            )}
            <span
              style={style as React.CSSProperties}
              className={`${styles.numberedSpan} hidden lg:block absolute right-0 left-0 top-0 bottom-0 m-auto h-fit`}
            >
              {index + 1}
            </span>
          </button>
        </>
      );    case "numberedSq":
      return (
        <>
          <button
            aria-label={"navigation slider buttons"}
            onClick={onClick}
            className={`${
              currentSlide === index ? " md:scale-120" : ""
            } relative `}
            key={index}
          >
            <span
              className={`lg:hidden ${currentSlide === index ? "w-6" : "w-2"} h-2 block transition-all`}
              style={{ backgroundColor: currentSlide === index ? activeColor?.hex : color?.hex }}
            />
            <span
              style={style as React.CSSProperties}
              className={`${styles.numberedSquareSpan} hidden lg:inline-block py-2 px-4 ${
                currentSlide !== index ? "border" : "border-[2px]"
              } `}
            >
              {index + 1}
            </span>
          </button>
        </>
      );    case "labelled":
      return (
        <>
          <button
            aria-label={"navigation slider buttons"}
            onClick={onClick}
            className={`${
              currentSlide === index ? " opacity-100" : "opacity-50"
            } relative py-2 text-xs  flex flex-row justify-center font-primary  `}
            key={index}
          >
            <span
              className={`lg:hidden ${currentSlide === index ? "w-6" : "w-2"} h-2 block rounded-full transition-all`}
              style={{ backgroundColor: currentSlide === index ? activeColor?.hex : color?.hex }}
            />
            <span
              style={style as React.CSSProperties}
              className={`${styles.labelledSpan} hidden lg:flex flex-row gap-1`}
            >
              {index + 1}/{length} <span className="hidden">{label}</span>
            </span>
            {currentSlide === index && (
              <span
                style={style as React.CSSProperties}
                className={`${styles.activeLine} hidden lg:block w-full absolute bottom-0 left-0 h-[1px]`}
              ></span>
            )}
          </button>
        </>
      );    case "traced":
      return (
        <>
          <button
            aria-label={"navigation slider buttons"}
            onClick={onClick}
            className={`${
              currentSlide === index ? " opacity-100" : "opacity-50"
            } relative py-2 text-xs  flex flex-row justify-center font-primary  `}
            key={index}
          >
            <span
              className={`lg:hidden ${currentSlide === index ? "w-6" : "w-2"} h-2 block rounded-full transition-all`}
              style={{ backgroundColor: currentSlide === index ? activeColor?.hex : color?.hex }}
            />
            <span
              style={style as React.CSSProperties}
              className={`hidden lg:flex ${
                currentSlide === index
                  ? `${styles.activeLine}`
                  : `${styles.tracerLine}`
              } flex-row gap-1 h-[2px] w-[1rem]`}
            ></span>
          </button>
        </>
      );    case "numberedTraced":
      return (
        <>
          <button
            aria-label={"navigation slider buttons"}
            onClick={onClick}
            className={`${
              currentSlide === index ? "opacity-100" : "opacity-50"
            } relative py-2 text-lg flex flex-row justify-center font-primary`}
            key={index}
          >
            <span
              className={`lg:hidden ${currentSlide === index ? "w-6" : "w-2"} h-2 block rounded-full transition-all`}
              style={{ backgroundColor: currentSlide === index ? activeColor?.hex : color?.hex }}
            />
            <span className="hidden lg:flex relative flex-col items-center">
              <span style={{ color: color.hex }} className="navigation">
                {index + 1}
              </span>
              <span
                style={style as React.CSSProperties}
                className={`${
                  currentSlide === index
                    ? `${styles.activeLine}`
                    : `${styles.tracerLine}`
                } flex flex-row gap-1 h-[2px] w-[1.5rem]`}
              ></span>
            </span>
          </button>
        </>
      );
    case "custom":
      return (
        <>
          <button
            aria-label={"navigation slider buttons"}
            onClick={onClick}
            className="relative flex flex-row justify-center"
            key={index}
          >
            <span
              className={`lg:hidden ${currentSlide === index ? "w-6" : "w-2"} h-2 block rounded-full transition-all`}
              style={{ backgroundColor: currentSlide === index ? activeColor?.hex : color?.hex }}
            />
            <span
              style={style as React.CSSProperties}
              className={`hidden lg:block h-[40px] w-[40px] ${
                currentSlide === index ? styles.activeCustom : styles.custom
              }`}
            />
          </button>
        </>
      );    default:
      return <></>;  }
};
